export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_LOADING = 'AUTH_LOADING'